/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserPermissionAssignmentDto } from './UserPermissionAssignmentDto';

export type SupportUserPermissionsDto = {
    domains: Array<UserPermissionAssignmentDto>;
    role: SupportUserPermissionsDto.role;
};

export namespace SupportUserPermissionsDto {

    export enum role {
        ADMIN = 'ADMIN',
        SYSTEM_EDITOR = 'SYSTEM_EDITOR',
        SYSTEM_VIEWER = 'SYSTEM_VIEWER',
    }


}
